import axios from "axios"

export async function createDocument(data){
    return await axios.post("simplefactura/document", data)
        .then(res => res.data)
        .catch(e => {
            if (e.response && e.response.data && e.response.data.error) {
                throw e.response.data.error
            }
            if (e.response && e.response.data) {
                throw e.response.data
            }
            throw e
        })
}

export async function fetchDocuments(query){
    return await axios.get("simplefactura/document?" + query)
        .then(res => res.data)
        .catch(e => {
            throw (e.response && e.response.data && e.response.data.error) || e
        })
}

export async function getDocument(id){
    return await axios.get("simplefactura/document/" + id)
        .then(res => res.data)
        .catch(e => {
            throw (e.response && e.response.data && e.response.data.error) || e
        })
}

export async function downloadDocumentPdf(id){
    return await axios.get("simplefactura/document/" + id + "/pdf", { responseType: "blob" })
        .then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }))
            window.open(url)
            return true
        })
        .catch(async e => {
            let message = "No se pudo obtener el PDF"
            if (e.response && e.response.data) {
                try {
                    const text = await e.response.data.text()
                    const parsed = JSON.parse(text)
                    message = parsed.error || message
                } catch (err) {
                    message = "No se pudo obtener el PDF"
                }
            }
            throw message
        })
}

export function mapDocumentToInvoiceRow(doc, customerName, workorder) {
    const raw = Array.isArray(doc.detalle) && doc.detalle.length
        ? doc.detalle
        : ((workorder && workorder.products) || [])
    const details = raw.map((item, index) => ({
        nro_linea: index + 1,
        sku: item.sku || (item.library_product && item.library_product.sku) || "",
        name: item.name || "",
        qty: Number(item.qty || 0),
        price: Number(item.price || 0),
    }))
    return {
        id: doc.dte || ("sf-" + doc.id),
        sf_id: doc.id,
        source: "simplefactura",
        document_id: doc.folio,
        date_emited: doc.created_at,
        payment_date: doc.payment_date || null,
        payment: doc.payment,
        rznSocRecep: doc.customer_name || customerName || "",
        rutRecep: doc.customer_rut || "",
        work_order: doc.workorder,
        sales_note: doc.sales_note,
        get_total: doc.total,
        get_subtotal: doc.neto,
        get_iva: doc.iva_amount,
        get_payed: Number(doc.payed || doc.get_payed || 0),
        iva: doc.neto ? Math.round((Number(doc.iva_amount || 0) / Number(doc.neto)) * 100) : 19,
        tipo: doc.tipo,
        tipo_display: doc.tipo_display,
        estatus: doc.estatus || 1,
        payments: doc.payments || [],
        referencia_folio: doc.referencia_folio || null,
        referencia_tipo: doc.referencia_tipo || null,
        referencia_tipo_display: doc.referencia_tipo_display || null,
        motivo: doc.motivo || null,
        motivo_display: doc.motivo_display || null,
        nc_reference: doc.nc_reference || null,
        details,
    }
}
